import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Heading, FormBox } from '../../StyledComponents/StyledComponents';
import FormGroup from 'react-bootstrap/es/FormGroup';
import { Col } from 'react-bootstrap';
import styled from 'styled-components';


const ThankYouText = styled.h2`
    font-size: 22px;
`;

class Complete extends Component {
  handleAddressChange = (address, fieldName) => {
    const { updateAddress } = this.props;
    updateAddress(address, fieldName);
  };

  render() {
    const {} = this.props;
    return (
      <>
        <FormGroup>
          <Col sm={12}>
            <Heading>Agency - Complete</Heading>
          </Col>
        </FormGroup>
        <FormBox>
          <ThankYouText>Thank you for submitting your Application, we will be in touch shortly</ThankYouText>
        </FormBox>
      </>
    );
  }
}

export default connect(() => {
  return {
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  };
})(Complete);
